import { render, staticRenderFns } from "./Приход по поставчикам.vue?vue&type=template&id=6edc6122&scoped=true"
import script from "./Приход по поставчикам.vue?vue&type=script&lang=js"
export * from "./Приход по поставчикам.vue?vue&type=script&lang=js"
import style0 from "./Приход по поставчикам.vue?vue&type=style&index=0&id=6edc6122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc6122",
  null
  
)

export default component.exports